class AgentConfig {
	maxStoredSessions: number | null = null;
	maxSteps: number | null = null;
	compactionTriggerPercent = 90;
	compactionTailUserCharsBudget = 20_000;
	toolPreviewMaxChars = 8_000;
	readMaxChars = 60_000;
	searchHitsLimit = 15;
	searchSnippetsPerHit = 2;
	searchSnippetSize = 160;
	searchTimeoutMs = 120_000;
	searchIndexProgressWaitMs = 300_000;
	repoExcludedPathPatterns = [/(^|\/)\.git(\/|$)/i];
	systemPrefix = "@system";
	skillPrefix = "@skills";
	binaryAttachmentExtensions = [
		"docx",
		"xlsx",
		"pdf",
		"mp3",
		"wav",
		"m4a",
		"flac",
		"ogg",
		"opus",
		"mp4",
		"mov",
		"avi",
		"mkv",
	];
	allowedAttachmentExtensions = [
		"txt",
		"md",
		"markdown",
		"json",
		"xml",
		"yaml",
		"yml",
		"csv",
		"html",
		"htm",
		"log",
		"ts",
		"tsx",
		"js",
		"jsx",
		"css",
		"sql",
		"ini",
		"toml",
		...this.binaryAttachmentExtensions,
	];
}

export const agentConfig = new AgentConfig();
